<template>
    <f7-page ptr @ptr:refresh="refreshData" @page:reinit="reinit" no-navbar>
        <home-header
                @addDevice="addDevice"
                @changeDevice="changeDevice"
                @updateDevice="updateDev"
                :penInfoError="penInfoError"
                :penInfo="penInfo"
                :penStatus="penStatus"
                :devId="currentDeviceId"
                :devName="currentDeviceName"
                :devVersion="devVersion"
                :devCanUpdate="devStatus && devCanUpdate"
                :devCount="devCount"
                :devStatus="devStatus">
        </home-header>
        <!-- <f7-list accordion-list>
             <f7-list-item accordion-item :title='currentDeviceName'>
                 <div slot='after'>
                     <f7Badge color="green" v-if="devStatus">在线</f7Badge>
                     <f7Badge color="grag" v-else>离线</f7Badge>
                 </div>
                 <f7-accordion-content>
                     <f7-list media-list>
                         <f7-list-item v-for="(device,index) in deviceList" :key="index" radio
                                       :checked="device.id===currentDeviceId"
                                       @change="changeDevice(device)"
                                       name='device'>
                             <div slot='title'>{{device.name?device.name:'设备'+(device.id)}}</div>
                         </f7-list-item>
                     </f7-list>
                 </f7-accordion-content>
             </f7-list-item>
             <f7-list-item title="设备版本" link v-if='devStatus && devCanUpdate' @click="updateDev">
                 <div slot='after'>
                     <f7Badge color="green">可更新</f7Badge>
                 </div>
             </f7-list-item>
             <f7-list-item title='点读笔信息：'>
                 <div slot='after'>
                     <template v-if='!penInfoError'>
                         <span v-if="devStatus && penStatus">{{penInfo}}</span>
                         <f7Badge color="grag" v-else>未连接</f7Badge>
                     </template>
                     <template v-else>
                         <span class='color-warn'>{{penInfoError}}</span>
                     </template>
                 </div>
             </f7-list-item>
         </f7-list>
        -->
        <section class='home-wrap'>
            <tabs v-model="currentItem" @change="changeTab">
                <tab v-for="(item,index) in tabList" :key="index" :title="item.label" :label="item.value"></tab>
            </tabs>
            <f7-tabs animated class='home-tabs'>
                <f7-tab class="tab-0">
                    <home-list media-list v-if="listFile.length>0">
                        <home-list-item v-for="(file,index) in listFile" link
                                        @click="goFileDetail(file,index,0)"
                                        swipeout
                                        @swipeout:deleted="handleDelFile(listFile,index)"
                                        :title="file.title"
                                        :key="index">
                            <div slot="subtitle">{{file.staticType.typeName}}-{{file.number}}</div>
                            <f7-swipeout-actions right>
                                <f7-swipeout-button delete confirm-text="确定删除此文件？">
                                    删除
                                </f7-swipeout-button>
                            </f7-swipeout-actions>
                        </home-list-item>
                    </home-list>
                    <home-notification v-else :msg="existData?packageMsg:'无数据'"></home-notification>
                </f7-tab>
                <f7-tab class="tab-1">
                    <home-list media-list v-if="mp3List.length>0">
                        <home-list-item v-for="(mp3,index) in mp3List"
                                        swipeout
                                        @swipeout:deleted="handleDelFile(mp3List,index)"
                                        :title="mp3.fileName"
                                        :key="index">
                            <f7-swipeout-actions right>
                                <f7-swipeout-button delete confirm-text="确定删除此文件？">
                                    删除
                                </f7-swipeout-button>
                            </f7-swipeout-actions>
                        </home-list-item>
                    </home-list>
                    <home-notification v-else :msg="existData?packageMsg:'无数据'"></home-notification>
                    <!--<div class='text-align-center'>{{existData?packageMsg:'无数据'}}</div>-->
                </f7-tab>
                <f7-tab class="tab-2">
                    <home-list media-list v-if="recordingList.length>0">
                        <home-list-item v-for="(recording,index) in recordingList"
                                        swipeout
                                        @swipeout:deleted="handleDelFile(recordingList,index)"
                                        :title="recording.fileName"
                                        :key="index">
                            <f7-swipeout-actions right>
                                <f7-swipeout-button delete confirm-text="确定删除此文件？">
                                    删除
                                </f7-swipeout-button>
                            </f7-swipeout-actions>
                        </home-list-item>
                    </home-list>
                    <home-notification v-else :msg="existData?packageMsg:'无数据'"></home-notification>
                </f7-tab>
                <f7-tab class="tab-3">
                    <home-list media-list v-if="installListFile.length>0">
                        <home-list-item v-for="(file,index) in installListFile" link
                                        @click="goFileDetail(file,index,1)"
                                        swipeout
                                        @swipeout:deleted="handleDelFile(installListFile,index)"
                                        :title="file.title"
                                        :key="index">
                            <div slot="subtitle">{{file.staticType.typeName}}-{{file.number}}</div>
                            <f7-swipeout-actions right>
                                <f7-swipeout-button @click="installPack(file,index)" color="green">安装
                                </f7-swipeout-button>
                                <f7-swipeout-button delete confirm-text="确定删除此文件？">
                                    删除
                                </f7-swipeout-button>
                            </f7-swipeout-actions>
                        </home-list-item>
                    </home-list>
                    <home-notification v-else :msg="existData?packageMsg:'无数据'"></home-notification>
                </f7-tab>
            </f7-tabs>
        </section>
        <base-toolbar slot="fixed"></base-toolbar>
    </f7-page>
</template>

<script type="text/ecmascript-6">
  import {
    f7Link,
    f7Toolbar,
    f7Block,
    f7List,
    f7ListItem,
    f7BlockTitle,
    f7Tabs,
    f7Tab,
    f7SwipeoutActions,
    f7SwipeoutButton,
    f7Icon,
    f7NavRight,
    f7Badge,
    f7Button,
    f7AccordionContent,
  } from 'framework7-vue'
  import { globalConst as native, getVuexState, modulesName, modalTitle, ERROR_TIMEOUT } from '../../lib/const'
  import { mapState } from 'vuex'
  import { hexToStr, hexToUTF8Str, isFun, Cache } from '../../lib/utils'
  import PackageFile, { FILE, SUFFIX_DAB } from 'lib/packageFile'
  import Tabs from 'components/baseTabsCtrl/BaseTabs'
  import Tab from 'components/baseTabsCtrl/BaseTab'
  import { bus } from 'src/main'
  import installPackageMixin from 'mixins/installPackageMixin'
  import HomeHeader from './chilren/Header'
  import HomeList from './chilren/List'
  import HomeListItem from './chilren/ListItem'
  import HomeNotification from './chilren/Notification'

  const tabList = [{label: '点读包', value: 0}, {label: '音乐', value: 1}, {label: '录音', value: 2}, {
    label: '待安装',
    value: 3
  }]
  export default {
    data () {
      return {
        tabList,
        currentItem: 0,
        existData: true,
        devStatus: false,
        penStatus: false,
        currentDeviceName: '',
        currentDeviceId: -1,
        reloadCount: 0,
        dataCacheMap: {},
        penInfoError: null,
        penInfo: '',
        devVersion: '',
        devCount: 0,
        devCanUpdate: false,
        updateDevTask: null,
        _loadServerUrlTask: null,
        orgOffset: 13
      }
    },
    mixins: [installPackageMixin],
    async created () {
      this.$store.commit('setActiveTabbarItem', 'home')
      this.$store.commit('clearListFile')
      let {dispatch, commit} = this.$store
      await dispatch({
        type: native.doLoadJsConfig
      }).catch((error) => {
        this.$f7router.navigate(`/error?message=${error}`, {clearPreviousHistory: true})
      })
      await this.loadNowVersion()
      this.loadDeviceList()
      if (this.macAddr) {
        this.loadData()
      }

      const tabIdx = this.$f7route.query && this.$f7route.query.tabIdx ? this.$f7route.query.tabIdx : 0
      setTimeout(() => {
        this.currentItem = tabIdx >>> 0
        this.changeTab(tabIdx)
      }, 0)
      bus.$on('loadData', () => {
        this.loadData()
      })
      // this.loadUSBInfo('http://192.168.16.254:10008')
    },
    mounted () {
    },
    methods: {
      reinit () {
      },
      go (url) {
        this.$f7router.navigate(url)
      },
      goFileDetail (file, index, canBeInstall) {
        this.$f7router.navigate(`/catalogs/package/${canBeInstall}/${index}`)
      },
      airkiss () {
        wx.ready(function () {
          // 在这里调用 API
          wx.invoke('configWXDeviceWiFi')
        })
        wx.error(function (res) {
          alert('配置出错')
        })
      },
      changeTab (value) {
        this.$f7.tab.show(`.tab-${value}`)
      },
      refreshData (event, done) {
        // this.loadServerUrlTask()
        if (!this.downLoaderServerUrl || !this.macAddr) {
          done()
          return
        }
        this.loadDeviceList()
        this.loadPenInfo()
        done()
      },
      loadNowVersion () {
        this.$store.dispatch({
          type: native.loadNowVersion,
          baseUrl: webServiceUrl,
        }).then(({data}) => {
        })
      },
      updateDev () {
        const {dispatch, commit} = this.$store
        this.$f7.dialog.confirm('是否升级设备', modalTitle, () => {
          bus.$emit('customLoading', {showLoading: true, loadingMsg: '设备升级中,请勿断电...'})
          dispatch({
            type: native.softwareUpdate,
            baseUrl: this.downLoaderServerUrl,
            url: this.newVersionUrl,
            flag: 'end'
          }).then((data) => {
            this.updateDevTask = setInterval(() => {
              dispatch({
                type: native.softwareUpdateProcess,
                baseUrl: this.downLoaderServerUrl
              }).then(({data}) => {
                const {hasTask, updateprocessbar} = data
                if (hasTask) {
                  bus.$emit('customLoading', {showLoading: true, loadingMsg: `设备升级中,请勿断电... ${updateprocessbar}%`})
                } else {
                  bus.$emit('customLoading', {showLoading: false})
                  clearInterval(this.updateDevTask)
                  this.updateDevTask = null
                  this.devVersion = ''
                  this.devCanUpdate = false
                  this.loadDeviceVersion()
                  this.$f7.dialog.confirm('设备更新完毕，需重启生效，是否重启设备？', modalTitle, () => {
                    dispatch({
                      type: native.reboot,
                      baseUrl: this.downLoaderServerUrl
                    }).then(() => {
                      commit('clearListFile')
                      this.devStatus = false
                      this.penStatus = false
                      this.existData = true
                      this.loadData()
                    })
                  })
                }
              })
            }, 3000)
          }).catch((error) => {
            console.log('error', error)
            this.$f7.dialog.alert(error, modalTitle)
            bus.$emit('customLoading', {showLoading: false, loadingMsg: '设备升级中...'})
          })
        })
      },
      changeDevice (deviceInfo) {
        let {dispatch, commit} = this.$store
        this.$store.state.showLoading_local = true
        this.$store.state.loadingMsg_local = '设备切换中，请稍候...'
        dispatch({
          type: native.changeDevice,
          macAddr: deviceInfo.macAddr
        }).then((data) => {
          this.currentDeviceId = deviceInfo.id
          this.currentDeviceName = deviceInfo.name || '设备' + deviceInfo.id
          commit('setDownLoaderServerUrl', '')
          commit('setMacAddr', deviceInfo.macAddr)
          this.loadData()
          this.$store.state.showLoading_local = false
          this.$store.commit('clearListFile')
        }).catch(() => {
          this.$store.state.showLoading_local = false
        })
        this.$f7.accordion.close('.accordion-item')
      },
      loadDeviceList () {
        let {dispatch, commit} = this.$store
        dispatch({
          type: native.loadDeviceList
        }).then(({data}) => {
          this.devCount = data.length
          if (data.length > 0) {
            const deviceInfo = data[0]
            this.currentDeviceName = deviceInfo.name || '设备' + deviceInfo.id
            this.currentDeviceId = deviceInfo.id
          } else {
            this.devStatus = false
            this.penStatus = false
            this.currentDeviceName = '请添加设备'
            this.currentDeviceId = -1
          }
        })
      },
      addDevice () {
        let that = this
        if (__DEBUG__) {
          // 1E:88:79:05:3A:86  1E:88:79:05:80:7E 1E:88:79:05:55:90
          let macAddr = '7c:a7:b0:ed:d2:de'
          let reg = /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi
          if (!reg.test(macAddr)) {
            that.$f7.dialog.alert('MAC地址格式不正确，请扫描正确的设备MAC地址...', modalTitle)
            return
          }
          that.$store.dispatch({
            type: native.doBindDevice,
            macAddr
          }).then(() => {
            that.$store.commit('setDownLoaderServerUrl', '')
            that.$store.commit('setMacAddr', macAddr)
            this.loadDeviceList()
            this.loadData()
          })
        } else {
          wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function (res) {
              var result = res.resultStr
              let reg = /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi
              if (!reg.test(result)) {
                that.$f7.dialog.alert('MAC地址格式不正确，请扫描正确的设备MAC地址...', modalTitle)
                return
              }
              that.$store.dispatch({
                type: native.doBindDevice,
                macAddr: result
              }).then(() => {
                that.$store.commit('setDownLoaderServerUrl', '')
                that.$store.commit('setMacAddr', result)
                that.loadDeviceList()
                bus.$emit('loadData')
              })
            }
          })
        }
      },
      loadData () {
        if (!this.downLoaderServerUrl) {
          this.loadServerUrlTask()
        } else {
          this.loadPenInfo()
        }
      },
      loadServerUrlTask () {
        if (!this.macAddr) {
          this.$f7.dialog.alert('请先获取设备信息', modalTitle)
          return
        }
        this.$store.dispatch({
          type: native.loadServerUrl,
          macaddr: this.macAddr,
          baseUrl: webServiceUrl,
          function: 'getdevice',
        }).then(({data}) => {
          console.log('获取设备的ip地址成功===》', data)
          if (!data.ipaddr) {
            this.devStatus = false
            if (this._loadServerUrlTask) {
              return
            }
            this._loadServerUrlTask = setInterval(() => {
              this.loadServerUrlTask()
            }, 3000)
            return
          }
          clearInterval(this._loadServerUrlTask)
          this._loadServerUrlTask = null
          let surl = `http://${data.ipaddr}:10008`
          this.$store.commit('setDownLoaderServerUrl', surl)
          this.loadData()
        }).catch(() => {
          this.devStatus = false
          if (this._loadServerUrlTask) {
            return
          }
          this._loadServerUrlTask = setInterval(() => {
            this.loadServerUrlTask()
          }, 3000)
        })
      },
      loadDeviceVersion () {
        this.$store.dispatch({
          type: native.getVersion,
          baseUrl: this.downLoaderServerUrl,
          newversion: this.newVersion,
          flag: 'end'
        }).then(({data}) => {
          console.log('version===>', data)
          this.devVersion = data.version
          this.devCanUpdate = data.update === 'true'
        })
      },
      loadPenInfo () {
        this.$store.dispatch({
          type: native.getDevice,
          baseUrl: this.downLoaderServerUrl,
          flag: 'end'
        }).then(({data}) => {
          console.log('笔信息', data)
          this.loadDeviceVersion()
          if (data) {
            const vendor = data.vendor
            const rev = data.rev
            const model = data.model
            if (vendor.trim() === 'maiya') {
              if (model === '908b' || model === '907' || model === '907s') {
                let versionInfo = ''
                switch (model) {
                  case '908b':
                    versionInfo = '908'
                    this.orgOffset = 13
                    break
                  case '907':
                  case '907s':
                    versionInfo = '907'
                    this.orgOffset = 14
                    break
                }
                this.penInfo = `小达人点读笔 ${versionInfo}` + rev
                this.devStatus = true
                this.penStatus = true
                this.$store.state.showLoading_local = false
                this.loadUSBInfo()
              } else {
                this.devStatus = true
                this.penStatus = false
                this.penInfoError = '此笔型号暂不支持'
                setTimeout(() => {
                  this.loadPenInfo()
                }, 3000)
              }
            } else {
              this.devStatus = true
              this.penStatus = false
              this.penInfoError = '非法笔'
              setTimeout(() => {
                this.loadPenInfo()
              }, 3000)
            }
          } else {
            this.devStatus = true
            this.penStatus = false
            setTimeout(() => {
              this.loadPenInfo()
            }, 3000)
          }
        }).catch((error) => {
          this.devStatus = error !== ERROR_TIMEOUT
          if (this.devStatus) {
            this.loadDeviceVersion()
          }
          this.penStatus = false
          this.$store.state.showLoading_local = false
          this.$store.commit('clearListFile')
          setTimeout(() => {
            this.loadPenInfo()
          }, 3000)
        })
      },
      async loadUSBInfo () {
        // // 读取系统盘信息
        await this.vuexApiCall(this.native.readEncryption, this.modulesName.downLoader, {
          baseUrl: this.downLoaderServerUrl
        })
        await this.vuexApiCall(this.native.readSerial, this.modulesName.downLoader, {
          baseUrl: this.downLoaderServerUrl,
          filename: 'SYS/INI/product.ini',
          org_offset: this.orgOffset,
          len: 11,
          flag: 'end'
        })
        // 读取指定u盘的内容
        let dst_dir = 'USER/CUSTOM'
        await this.$store.dispatch({
          type: native.listFile,
          baseUrl: this.downLoaderServerUrl,
          dst_dir,
          flag: 'end'
        }).then(({data}) => {
          this.$store.commit('clearListFile')
          if (data.length <= 0) {
            this.existData = false
          }
          this.reloadCount++
          this.$set(this.dataCacheMap, this.reloadCount, {
            listFile: [],
            recordingList: [],
            mp3List: [],
            installListFile: [],
          })
          // ['readBeforeThreeBit', 'readTitle', 'readGuid', 'complate']
          let dataCursor = 0
          data.forEach(async (row) => {
            let reloadCount = this.reloadCount
            let packageFile = new PackageFile(row.type, row.fileName, dst_dir)
            if (packageFile.type === FILE && packageFile.isPackageFile) {
              let {readBeforeThreeBit, readTitle, readGuid, complate} = packageFile.hooks
              if (readBeforeThreeBit && isFun(readBeforeThreeBit)) {
                await this.$store.dispatch({
                  type: native.readBeforeThreeBit,
                  baseUrl: this.downLoaderServerUrl,
                  filename: packageFile.path,
                }).then(({data}) => {
                  let threeBit = ''
                  try {
                    threeBit = hexToUTF8Str(data)
                  } catch (e) {
                    threeBit = 'other'
                  }
                  readBeforeThreeBit.bind(packageFile)(threeBit)
                })
              }
              const readUNBBitCheckType = packageFile.hooks.readUNBBitCheckType
              if (readUNBBitCheckType && isFun(readUNBBitCheckType)) {
                await this.$store.dispatch({
                  type: native.readBlock,
                  baseUrl: this.downLoaderServerUrl,
                  filename: packageFile.path,
                  org_offset: 95,
                  len: 2,
                  flag: 'end'
                }).then(({data}) => {
                  readUNBBitCheckType.bind(packageFile)(data)
                })
              }
              if (readTitle && isFun(readTitle)) {
                await this.$store.dispatch({
                  type: native.readBlock,
                  baseUrl: this.downLoaderServerUrl,
                  filename: packageFile.path,
                  org_offset: packageFile.staticType.titleIdx,
                  len: packageFile.staticType.titleLen,
                  flag: 'end'
                }).then(({data}) => {
                  readTitle.bind(packageFile)(hexToStr(data))
                })
              }
              if (readGuid && isFun(readGuid)) {
                await this.$store.dispatch({
                  type: native.readBlock,
                  baseUrl: this.downLoaderServerUrl,
                  filename: packageFile.path,
                  org_offset: packageFile.staticType.guidIdx,
                  len: packageFile.staticType.guidLen,
                  flag: 'end'
                }).then(({data}) => {
                  readGuid.bind(packageFile)(hexToUTF8Str(data))
                })
              }
              if (complate && Object.prototype.toString.call(complate) === '[object Function]') {
                if (!packageFile.isATT) {
                  if (packageFile.suffix === SUFFIX_DAB) {
                    this.dataCacheMap[reloadCount].installListFile.push(complate.bind(packageFile)())
                    // this.installListFile.push(complate.bind(packageFile)())
                    dataCursor++
                  } else {
                    this.dataCacheMap[reloadCount].listFile.push(complate.bind(packageFile)())
                    // this.listFile.push(complate.bind(packageFile)())
                    dataCursor++
                  }
                  if (dataCursor === data.length) {
                    console.log('完成')
                    this.loadDataComplete()
                  }

                }
              }
            } else if (packageFile.type === FILE) {
              if (packageFile.suffix === 'mp3' || packageFile.suffix === 'mp4') {
                this.dataCacheMap[reloadCount].mp3List.push(packageFile)
                // this.mp3List.push(packageFile)
                dataCursor++
              } else if (packageFile.suffix === 'wav') {
                this.dataCacheMap[reloadCount].recordingList.push(packageFile)
                // this.recordingList.push(packageFile)
                dataCursor++
              } else {
                dataCursor++
              }
              if (dataCursor === data.length) {
                console.log('完成2')
                this.loadDataComplete()
              }
            } else {
              dataCursor++
              if (dataCursor === data.length) {
                console.log('完成3')
                this.loadDataComplete()
              }
            }
          })
        })
      },
      loadDataComplete () {
        this.$store.commit('clearListFile')
        this.listFile.push(...this.dataCacheMap[this.reloadCount].listFile.sort(this.packageSort))
        this.recordingList.push(...this.dataCacheMap[this.reloadCount].recordingList.sort(this.packageSort))
        this.mp3List.push(...this.dataCacheMap[this.reloadCount].mp3List.sort(this.packageSort))
        this.installListFile.push(...this.dataCacheMap[this.reloadCount].installListFile.sort(this.packageSort))
        this.existData = false
      },
      packageSort (packageA, packageB) {
        if (packageA.title.charCodeAt(0) - packageB.title.charCodeAt(0) === 0) {
          return (packageA.number >>> 0) - (packageB.number >>> 0)
        } else {
          return packageA.title.charCodeAt(0) - packageB.title.charCodeAt(0)
        }
      },
      handleDelFile (dataList, index) {
        let packageFile = dataList[index]
        this.vuexApiCall({
          type: native.delFile,
          apiParams: {
            baseUrl: this.downLoaderServerUrl,
            filename: packageFile.path,
            flag: 'end'
          }
        }).then(() => {
          this.$f7.dialog.alert('删除成功', () => {
          })
        }).catch(() => {
          this.$f7.dialog.alert('删除失败', () => {})
        })
      },
    },
    computed: {
      ...mapState({
        /* listFile: getVuexState(modulesName.downLoader, native.listFile),*/
        listFile: ({downLoader}) => downLoader.listFile,
        recordingList: ({downLoader}) => downLoader.recordingList,
        mp3List: ({downLoader}) => downLoader.mp3List,
        installListFile: ({downLoader}) => downLoader.installListFile,
        downLoaderServerUrl: ({downLoader}) => downLoader.downLoaderServerUrl,
        macAddr: ({downLoader}) => downLoader.macAddr,
        deviceList: ({device}) => device.deviceList,
        newVersion: ({common}) => common.newVersion,
        newVersionUrl: ({common}) => common.newVersionUrl
      }),
      packageMsg: function () {
        if (!this.macAddr) {
          return '请扫描设备二维码，获取设备信息...'
        }
        if (!this.downLoaderServerUrl) {
          return '模块联网中，请稍等片刻...'
        }
        if (!this.devStatus) {
          return '请开启设备...'
        }
        if (!this.penStatus) {
          return '请将笔连接设备...'
        }
        return '数据加载中，请稍后...'
      }
    },
    destroyed () {
      bus.$off('loadData')
      clearInterval(this._loadServerUrlTask)
      this._loadServerUrlTask = null
    },
    components: {
      f7Link,
      f7Toolbar,
      f7Block,
      f7List,
      f7BlockTitle,
      f7ListItem,
      f7Tabs,
      f7Tab,
      Tabs,
      Tab,
      f7SwipeoutActions,
      f7SwipeoutButton,
      f7Icon,
      f7NavRight,
      f7Badge,
      f7Button,
      f7AccordionContent,
      HomeHeader,
      HomeList,
      HomeListItem,
      HomeNotification
    }
  }
</script>
<style lang="scss" scoped type="text/css">
    @import "home.scss";
</style>
